import { IFormatRuleMap, TDateFormatMap } from "./_type";

// 数据格式化规则集合
export const FORMAT_RULE_MAP: IFormatRuleMap = {
  // 整数
  int: '0',
  // 保留一位小数
  oneDecimal: '0.0',
  // 保留两位小数
  twoDecimal: '0.00',
  // 百分比保留一位小数
  percent1Decimal: 'db_percent_1_decimal',
  // 百分比保留两位小数
  percent2Decimal: 'db_percent_2_decimal',
  // 百分比整数（正值）
  absPercentInt: 'db_abs_percent_int',
  // 百分比1位小数（正值）
  absPercent1Decimal: 'db_abs_percent_1_decimal',
  // 百分比2位小数（正值）
  absPercent2Decimal: 'db_abs_percent_2_decimal',
  // 百分比保留整数
  percentInt: 'percent_int',
  // 千分位
  thousandsInit: '0,0',
  // 千分位一位小数
  thousands1Decimal: '0,0.0',
  // 千分位两位小数
  thousands2Decimal: '0,0.00',
  // bmk处理
  bmk: 'db_bmk',
  // bmk一位小数
  bmk0: 'db_bmk0',
  // bmk两位小数
  bmk00: 'db_bmk00',
  /** 与移动端命名对齐，语义同 bmk00（两位小数 BMK） */
  twoDecimalBmk00: 'db_2_bmk00',
  // 卡片位指标数值超过百万，需要增加单位M|B，不超过百万，则千分位正数展示
  bm: 'db_bm',
  // 卡片位指标数值超过百万，需要增加单位M|B，不超过百万，则千分位一位小数展示
  bm0: 'db_bm0',
  // 卡片位指标数值超过百万，需要增加单位M|B，不超过百万，则千分位两位小数展示
  bm00: 'db_bm00',
  // 小数极小值
  small2Decimal: 'db_small_2_decimal',
  // 百分比极小值
  smallPercent1Decimal: 'db_small_percent_1_decimal',
  // 坐标轴百分比极小值
  axisSmallPercent2Decimal: 'db_axis_small_percent_2_decimal',
  // value小于1000取整数，大于1000保留整数bmk格式
  intBmk: 'db_int_bmk',
  // value小于1000取整数，大于1000保留一位小数bmk格式
  intBmk0: 'db_int_bmk0',
  // value小于1000取整数，大于1000保留两位小数bmk格式
  intBmk00: 'db_int_bmk00',
  // value小于1000取整数，大于1000保留一位小数bmk格式(去0)
  not0IntBmk0: 'db_int_bmk0_1_0',
  // value小于百万取整数，大于百万保留整数bm格式
  intBm: 'db_int_bm',
  // value小于百万取整数，大于百万保留一位小数bm格式
  intBm0: 'db_int_bm0',
  // value小于百万取整数，大于百万保留两位小数bm格式
  intBm00: 'db_int_bm00'
};

// 导出int格式化字段数组
export const INT_FORMAT_ARRAY = ['int', 'thousandsInit', 'bmk', 'bm', 'intBmk', 'intBm'];
// 极小值处理相关，计算极小值时，需要保留的位数
export const MIN_VALUE_LIMITS = [0.000001, 0.00001, 0.0001, 0.001];
export const MIN_VALUE_DEFAULTS = [6, 5, 4, 3];

// 极小值处理相关，计算极小值时，需要保留的位数
export const PRECISION_LIMITS = [0.000001, 0.00001, 0.0001, 0.001, 0.01, 0.1];
export const PRECISION_MAP = [8, 7, 6, 5, 4];

// 日期处理规则map
export const DATE_FORMATE_MAP: TDateFormatMap = {
  day: 'YYYY-MM-DD',
  mDay: 'MM-DD',
  month: 'YYYY-MM',
  hour: 'HH:mm',
  year: 'YYYY',
  minutes: 'YYYY-MM-DD HH:mm',
};

export const EXTRA_FORMATS = ['YYYYMM', 'YYYYMMDD', 'YYYYMMDDHHmm', 'YYYYMMDDHHmmss'];
